import {loadMasks} from '../functions';

class Ocorrencia {

  static aplicarOcorrencia($this) {

    $this.prop('disabled', true);

    $('.preloader').show();

    const $id = $('#id');
    const $empresa = $('#empresa');
    const $usuario = $('#usuario');
    const $status = $('#status');
    const $origem = $('#origem');
    const $origem_outros = $('#origem_outros');
    const $ocorrencia = $('#ocorrencia');
    const $agrupamento = $('#agrupamento');

    $.ajax({
      type: 'POST',
      url: `/ocorrencias`,
      data: {
        id: $id.val(),
        empresa_id: $empresa.val(),
        id_usuario: $usuario.val(),
        status: $status.val(),
        origem: $origem.val(),
        origem_outros: $origem_outros.val() || '',
        ocorrencia: $ocorrencia.val(),
        agrupamento: $agrupamento.val(),
      },
    }).done(response => {
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: `A ocorrência foi salva com sucesso.`,
      }).then(result => {
        if (result) {
          const $redirectUrl = $('#redirect_url');
          if ($redirectUrl.length > 0) {
            window.location = $redirectUrl.val();
          } else {
            window.location = response.url;
          }
        }
      });

    }).fail(response => {

      let errorHTML = response.responseText;

      if (response.status === 412) {

        const errors = (response.responseJSON.errors);

        let messages = [];
        let $firstFocus = null;

        for (let error in errors) {
          if (!$firstFocus) {
            $firstFocus = $(`#${error}`);
          }
          $(`#${error}`).closest('.form-group').addClass('invalid-data');
          messages.push(`<li>${errors[error]}</li>`);
        }

        const acao = parseInt($id.val()) === 0 ? 'cadastrar' : 'alterar';

        errorHTML = `
            Não foi possível ${acao} a ocorrência.
            <br>Verifique os campos em vermelho.
          `;
      }

      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: errorHTML,
      });
    }).always(() => {
      $this.prop('disabled', false);
      $('.preloader').hide();
    });
  }

  static excluirOcorrencia($this) {
    Swal.fire({
      icon: 'error',
      title: 'Aviso!',
      html: `Deseja realmente excluir esta Ocorrência?`,
    }).then(result => {
      if (result) {
        $('.preloader').show();
        $.ajax({
          type: 'DELETE',
          url: `/ocorrencias/${$this.val()}`,
        }).done(function (response) {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            html: `A ocorrência foi excluída!`,
          });
          window.location.reload();
        });
      }
    });
  }

  static listen() {
    jQuery(function () {
      loadMasks();

      $('input, select').closest('.form-group').addClass('focused');

      $(document).on('change', '#empresa', function (e) {
        $('.aplicar-ocorrencia').val($(this).val());
      });

      $(document).on('click', '#formOcorrencia .aplicar-ocorrencia', function (e) {
        const $this = $(this);
        e.preventDefault();
        e.stopImmediatePropagation();
        Ocorrencia.aplicarOcorrencia($this);
      });

      $(document).on('click', '.ver-ocorrencia', function () {
        const $this = $(this);

        const ocorrencia = $this.closest('TR').data('ocorrencia');

        let membros = [];

        if (ocorrencia.membros && ocorrencia.membros.length > 0) {
          membros.push(`<hr><h6>Membros desse grupo</h6>`);
          membros.push(`<ul class="list-group mt-2" style="min-width: 100%">`);
          ocorrencia.membros.forEach(membro => {
            membros.push(`<li class="list-group-item py-1 px-2">${membro}</li>`);
          });
          membros.push('</ul>');
        }

        const title = `
                  <h3>
                    ${ocorrencia.criador}
                    <br>em ${ocorrencia.data_cadastro}
                  </h3>
                  <h2>${ocorrencia.origem}</h2>
                  <p class="mb-0">
                    <strong class="pr-2">CNPJ</strong>${ocorrencia.cnpj}
                    <br><strong class="pr-2">CCM</strong>${ocorrencia.ccm}
                  </p>
                `;

        const observacao = $(`#ocorrencia-${$this.val()}`).html() + membros.join('');

        $('#modalOcorrencia .modal-title').html(title);
        $('#modalOcorrencia .modal-body').html(observacao);
        $('#modalOcorrencia').modal('show');
      });

      $(document).on('click', '.excluir-ocorrencia', function (e) {
        const $this = $(this);
        Ocorrencia.excluirOcorrencia($this);
      });
    });
  }
}

export default Ocorrencia;
